import type { Incident } from '../realtime/contracts';

export function orderIncidentsByCreatedTimeDescending(incidents: readonly Incident[]): Incident[] {
  return [...incidents].sort((a, b) => Date.parse(b.createdAtUtc) - Date.parse(a.createdAtUtc));
}
